function accountController($scope, currentUser, Subscriber, AppAuthFactory, previousSubscriptions, enqueuedSubscriptions, $timeout) {
  'ngInject';

  let emailAddress = currentUser.email;
  $scope.currentUser = currentUser;
  $scope.subscription = currentUser.subscription;
  $scope.myCause = currentUser.subscription.cause;
  $scope.membership = currentUser.subscription.key;
  $scope.enqueuedSubscriptions = enqueuedSubscriptions;
  $scope.account_deletion_started = false;
  $scope.delete_reason = "";
  $scope.delete_reason_verbose = "";
  console.log($scope.enqueuedSubscriptions);
  $scope.previousSubscriptions = previousSubscriptions;
  console.log($scope.previousSubscriptions);
  const sub = $scope.subscription,
  startDate = new Date().getTime(),
  endDate = new Date(sub.expires).getTime(),
  diffDate = Math.round((endDate-startDate)/(1000*60*60*24));

  $scope.expires = diffDate;

  $scope.emailSent = false;

  $scope.sendVerificationEmail = function() {
    Subscriber.verifySubscriberById({"id": $scope.currentUser.id})
      .$promise.then(function(res) {
        $scope.emailSent = true;

        // $timeout(function() {
        //   $scope.emailSent = false;
        // }, 5000);
      }, function(err) {
        console.log('errored', err);
      });
  };

  $scope.beginAccountDeletion = function() {
    $scope.account_deletion_started = true;
  }

  $scope.accountDeletionRequestSuccess = false;
  $scope.deleteAccount = function() {
    let reason =  $scope.delete_reason + " " + $scope.delete_reason_verbose;
    Subscriber.requestDeletionById({
      "deletion": {
        "subscriber_id": $scope.currentUser.id,
        "reason": reason.trim()
      }
    }).$promise.then(function(res) {
      $scope.accountDeletionRequestSuccess = true;
      $scope.delete_reason = "";
      $scope.delete_reason_verbose = "";
    }, function(err) {
      console.log('errored', err);
    });
  };

  $scope.profileUpdated = false;
  $scope.updateProfile = function() {
    if($scope.currentUser.email !== emailAddress) {
      $scope.currentUser.emailVerified = false;
    }
    AppAuthFactory.getCurrentSubscriber((currentUserData) => {
      Object.assign(currentUserData, $scope.currentUser);
      var promise = currentUserData.$save();
      promise.then(function(res) {
        $scope.profileUpdated = true;
        $timeout(function() {
          $scope.profileUpdated = false;
        }, 2000);
        if(res.email !== emailAddress) {
          emailAddress = res.email;
          $scope.sendVerificationEmail();
          //show dialog and send email verifcation
        }
      }, function(err) {
        console.log('errored', err);
      });
    });
  };

  $scope.passwordObj = {
    old_password: '',
    confirm: '',
    new_password: ''
  };

  $scope.passwordSaved = false;
  $scope.passwordSaveError = false;
  $scope.showPassMsg = false;
  
  $scope.updatePassword = function() {
    var passwordUpdate = angular.extend({}, $scope.passwordObj);
    delete passwordUpdate.confirm;
    Subscriber.prototype$changePassword({"id" : $scope.currentUser.id}, {passwords: passwordUpdate})
    .$promise.then(function(res) {
      $scope.passwordSaved = true;
      $scope.passwordObj = {
        old_password: '',
        confirm: '',
        new_password: ''
      };

      $timeout(function() {
        $scope.passwordSaved = false;
      }, 2000);
    }, function(err) {
      $scope.passwordSaveError = true;
      $timeout(function() {
        $scope.passwordSaveError = false;
      }, 2000);
      console.log('erroed', err);
    });
  };

}

export default accountController;



// WEBPACK FOOTER //
// ./js/containers/dashboard/controllers/accountController.js